import React, { useEffect } from "react";
// ANT DESIGN COMPONENTS
import { Modal, Spin } from "antd";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { usePutBankActionMutation } from "../../../redux/banks/bankAPI";
import { updateOpenModalDeleteBankAction, updateBankAction } from "../../../redux/banks/bankSlice";
// COMPONENTS
import ModalDeleteItemContainer from "../../components/modal/ModalDeleteItemContainer";
import GlobalAlert2 from "../../home/GlobalAlert2";
// AUTHORIZATION
import GETJwtToken from "../../../redux/authentication/authentication";
// INTERFACES
import { RootState } from "../../../app/store";
// CONSTANTS
import { BLANK_BANK_ACTION } from "../../../constants/bank";
// FLATBUFFER DISPLAY HELPERS
import { formatUuidT } from "../../../flatbuffers/display";
import { toUpdateBankActionsRequest } from "../../../redux/banks/bankActionRequest";

function BankactionsDeleteModal() {
  // LOCAL STORAGE AND VARIABLES ******************** */
  const dispatch = useDispatch();

  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { bankAction, openModalDeleteBankAction } = useSelector((state: RootState) => state.bank);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */
  const [triggerDeleteAction, { isLoading, isSuccess, isError, error, reset: resetDeleteAction }] =
    usePutBankActionMutation();

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onClickClose = () => {
    dispatch(updateOpenModalDeleteBankAction(false));
  };

  const onClickDelete = async () => {
    const token = await GETJwtToken();
    // `bankAction.bankId` is a decoded FlatBuffer UuidT despite the interface
    // declaring it `string`; interpolating it raw put "[object Object]" in the
    // URL and the request 400'd before it reached the row.
    triggerDeleteAction({
      id: formatUuidT(bankAction.bankId),
      token,
      body: toUpdateBankActionsRequest([], [bankAction.messageId], bankAction.bankId),
    });
    dispatch(updateBankAction({ ...BLANK_BANK_ACTION }));
  };

  // ************************************************* */
  // USE EFFECT ************************************** */
  useEffect(() => {
    if (openModalDeleteBankAction) {
      resetDeleteAction();
    }
  }, [openModalDeleteBankAction]);

  useEffect(() => {
    if (isSuccess || isError) {
      dispatch(updateBankAction({ ...BLANK_BANK_ACTION }));
      onClickClose();
    }
  }, [isSuccess, isError]);
  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <Modal
      onOk={onClickClose}
      closable={false}
      onCancel={onClickClose}
      open={openModalDeleteBankAction}
      footer={null}
    >
      <Spin spinning={isLoading}>
        <ModalDeleteItemContainer
          name={bankAction.label}
          onClickDelete={onClickDelete}
          onClickClose={onClickClose}
        />
      </Spin>
      {/** ---------------------------------------------------- */}
      {/** GLOBAL ALERT */}
      <GlobalAlert2
        isError={isError}
        isSuccess={isSuccess}
        requestType="DELETE"
        error={error}
        name="Action"
      />
    </Modal>
  );
}

export default BankactionsDeleteModal;
